import React from 'react';

const PricingArchitecturePlaceholder = React.memo(() => {
	return <div className="grid grid-cols-1 gap-4 sm:grid-cols-3">
		<div className="col-span-1">
			<div className="mx-auto bg-gray-50 p-3 rounded-lg border border-gray-100">
				<ul role="list" className="space-y-3 text-sm leading-6 text-gray-600"></ul>
				<div className="overflow-hidden">
					<ul className="space-y-3">
						<li className="rounded-lg bg-white/5 border border-gray-200 p-6 space-y-2">
							<div className="w-1/3 h-3 bg-gray-200 rounded-md"></div>
							<div className="w-full h-4 bg-gray-200 rounded-md"></div>
						</li>
						<li className="rounded-lg bg-white/5 border border-gray-200 p-6 space-y-2">
							<div className="w-1/3 h-3 bg-gray-200 rounded-md"></div>
							<div className="w-full h-4 bg-gray-200 rounded-md"></div>
						</li>
						<li className="rounded-lg bg-white/5 border border-gray-200 p-6 space-y-2">
							<div className="w-1/3 h-3 bg-gray-200 rounded-md"></div>
							<div className="w-full h-4 bg-gray-200 rounded-md"></div>
						</li>
						<li className="rounded-lg bg-white/5 border border-gray-200 p-6 space-y-2">
							<div className="w-1/3 h-3 bg-gray-200 rounded-md"></div>
							<div className="w-full h-4 bg-gray-200 rounded-md"></div>
						</li>
					</ul>
				</div>
			</div>
		</div>
		<div className="sm:col-span-2">
			<div className="mx-auto bg-gray-50 p-3 rounded-lg border border-gray-100">
				<div className="bg-white rounded-lg shadow p-4">
					<div className="my-4">
						<ul className="space-y-3">
							<li className="rounded-lg bg-white/5 border border-gray-200 p-6 space-y-2">
								<div className="w-1/3 h-3 bg-gray-200 rounded-md"></div>
								<div className="w-full h-4 bg-gray-200 rounded-md"></div>
							</li>
							<li className="rounded-lg bg-white/5 border border-gray-200 p-6 space-y-2">
								<div className="w-1/3 h-3 bg-gray-200 rounded-md"></div>
								<div className="w-full h-4 bg-gray-200 rounded-md"></div>
							</li>
							<li className="rounded-lg bg-white/5 border border-gray-200 p-6 space-y-2">
								<div className="w-1/3 h-3 bg-gray-200 rounded-md"></div>
								<div className="w-full h-4 bg-gray-200 rounded-md"></div>
							</li>
						</ul>
					</div>
				</div>
			</div>
		</div>
	</div>
})

export default PricingArchitecturePlaceholder;
